"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "envelopePhoneSvg", {
  enumerable: true,
  get: function get() {
    return _envelopePhone.default;
  }
});
Object.defineProperty(exports, "profileThumb", {
  enumerable: true,
  get: function get() {
    return _defaultProfileThumb.default;
  }
});
Object.defineProperty(exports, "shiffyAvatar", {
  enumerable: true,
  get: function get() {
    return _shiffyAvatar.default;
  }
});
Object.defineProperty(exports, "vtoAvatar", {
  enumerable: true,
  get: function get() {
    return _vtoAvatar.default;
  }
});

var _envelopePhone = _interopRequireDefault(require("./envelope-phone.svg"));

var _defaultProfileThumb = _interopRequireDefault(require("./default-profile-thumb.svg"));

var _shiffyAvatar = _interopRequireDefault(require("./shiffy-avatar.svg"));

var _vtoAvatar = _interopRequireDefault(require("./vto-avatar.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }